import BaseService from "../BaseService";
import _ from "lodash";

class CollaboratorUser extends BaseService {
    statistic = async () => {
        var data = await this._api.get("/collaborator/statistic");
        return data;
    };
}
export default CollaboratorUser;
